import React, {Component} from 'react';
import { connect } from 'react-redux';
import './styles.css';
import { isAdmin } from '../../helpers';

const MENU = [
    {match: /^\/$/,          title: 'Home',        path: '/#/',         icon: 'fa-home',           admin: false},
    {match: /^\/myreports/,  title: 'My Reports',  path: '/#/myreports', icon: 'fa-file-text-o',   admin: false},
    {match: /^\/vacation$/,  title: 'My Vacations',path: '/#/vacation',  icon: 'fa-suitcase',      admin: false},
    {match: /^\/calendar/,   title: 'Calendar',    path: '/#/calendar',  icon: 'fa-calendar-o',    admin: false},
    {match: /^\/reports/,    title: 'Reports',     path: '/#/reports',   icon: 'fa-bar-chart',     admin: true},
    {match: /^\/vacations/,  title: 'Vacations',   path: '/#/vacations', icon: 'fa-check-square-o',admin: true},
    {match: /^\/projects/,   title: 'Projects',    path: '/#/projects',  icon: 'fa-folder-o',      admin: true},
    {match: /^\/users/,      title: 'Users',       path: '/#/users',     icon: 'fa-users',         admin: true},
    {match: /^\/holidays/,   title: 'Holidays',    path: '/#/holidays',  icon: 'fa-star-o',        admin: true},
];

class Sidebar extends Component {

    _renderItem(item, i, pathname) {
        const active = item.match.test(pathname) ? 'active' : '';
        return (
            <li key={'sidebar_' + i} className={active}>
                <a href={item.path} onClick={this.props.onNavigate}>
                    <i className={'nav-ico fa ' + item.icon} aria-hidden="true" />
                    <span>{item.title}</span>
                </a>
            </li>
        );
    }

    render() {
        const user = this.props.user || {};
        const admin = isAdmin(user);
        const pathname = this.props.location.pathname;
        const initials = ((user.firstName || ' ')[0] + (user.lastName || ' ')[0]).toUpperCase().trim() || 'U';

        const personal = MENU.filter(m => !m.admin);
        const adminItems = MENU.filter(m => m.admin);

        return (
            <aside className="App-Sidebar">
                <div className="Sidebar-Brand">
                    <span className="Brand-Glyph"><i className="fa fa-suitcase" aria-hidden="true" /></span>
                    <span>
                        Portal
                        <small>Time &amp; Rest</small>
                    </span>
                </div>

                <nav className="Sidebar-Nav">
                    <ul>
                        {personal.map((item, i) => this._renderItem(item, i, pathname))}
                    </ul>

                    {admin &&
                        <div>
                            <div className="Sidebar-Section">Admin</div>
                            <ul>
                                {adminItems.map((item, i) => this._renderItem(item, 'a' + i, pathname))}
                            </ul>
                        </div>
                    }
                </nav>

                <div className="Sidebar-Foot">
                    <span className="Avatar">{initials}</span>
                    <span className="Who">
                        <span className="n">{(user.firstName || '') + ' ' + (user.lastName || '')}</span>
                        <span className="e">{user.email || ''}</span>
                    </span>
                </div>
            </aside>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.authentication.user
    };
}

export default connect(mapStateToProps)(Sidebar);



// WEBPACK FOOTER //
// ./src/components/Sidebar/index.js